import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
export function HighPowerSection() {
  return <div className="bg-gray-100 rounded-2xl p-8 md:p-12 text-center max-w-4xl mx-auto border border-gray-200" data-id="element-1022">
      <h2 className="text-3xl font-bold text-[#f5693d] mb-4" data-id="element-1023">
        High Power Laser Cutting Machines
      </h2>
      <h3 className="text-xl font-bold text-[#002d4d] mb-6" data-id="element-1024">
        <a href="https://www.peakedm.com/uploaded/files/Bodor%20Files/Why%20we%20need%20a%2010kw+%20fiber%20laser-2021.03.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="hover:underline" data-id="element-1025">
          Why Do We Need A 10kW+ Fiber Laser?
        </a>
      </h3>
      <div className="text-gray-700 space-y-4 text-lg leading-relaxed" data-id="element-1026">
        <p data-id="element-1027">
          For laser cutting machines, the higher the power, the faster the speed
          and the higher the efficiency. It can help shorten delivery time
          resulting in higher profit margins for the company.
        </p>
        <p className="font-medium" data-id="element-1028">
          In stainless steel cutting, the processing speed of 12,000W laser
          machine is 3.4 times that of 6kW.
        </p>
        <div className="pt-4" data-id="element-1029">
          <a href="https://www.peakedm.com/uploaded/files/Bodor%20Files/Why%20we%20need%20a%2010kw+%20fiber%20laser-2021.03.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#f5693d] font-bold hover:text-[#d45025] transition-colors" data-id="element-1030">
            Read more here <ExternalLinkIcon className="w-4 h-4 ml-2" data-id="element-1031" />
          </a>
        </div>
      </div>
    </div>;
}